/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCurrentEditor } from "@tiptap/react";
import { useUpdateDocument } from "cms/rich-text/simplicity-composer-tiptap/document/use-update-document";
import Button from "@mui/material/Button";
import { IconEdit, IconSelect } from "@tabler/icons-react";
import { Logger } from "cms/utils/log/logger";

export const DocumentDisplay = (props) => {
    
    const markType = "doclink";
    const { setOpen, setOpenEdit } = props;
    const { t } = useTranslation();
    const { editor } = useCurrentEditor();
    const { doclink } = useUpdateDocument();
    const [loaded, setLoaded] = useState(false);
    
    useEffect(() => {
        const { guid } = doclink || {};
        if (guid === null && !loaded) {
            setOpen(true);
            setLoaded(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [doclink]);
    
    const onOpenDocumentSelector = () => {
        if (typeof setOpen === "function") {
            setOpen(true);
            setLoaded(false);
        } else {
            Logger.warn("setOpen was not a function, could not open document selector");
        }
    };
    const onOpenDocumentEditor = () => {
        if (typeof setOpenEdit === "function") {
            const { guid } = doclink || {};
            if (guid !== null) {
                setOpenEdit(true);
                setLoaded(false);
            }
        } else {
            Logger.warn("setOpenEdit was not a function, could not open document editor");
        }
        
    };
    const onRemoveDocument = () => {
        editor.chain().focus().extendMarkRange(markType).unsetMark(markType).run();
        setOpen(false);
        setLoaded(false);
    };
    
    return (
        <div className="simplicity-richtext-composer-editor-tooltip">
            <span className='simplicity-richtext-composer-editor-tooltip-text'>
                {doclink?.text}
            </span>
            <div className='simplicity-richtext-composer-editor-tooltip-buttons'>
                <div>
                    <Button
                        variant='text'
                        onClick={onOpenDocumentSelector}
                        startIcon={<IconSelect/>}
                    >
                        {t("Editor.select")}
                    </Button>
                </div>
                <div>
                    <Button
                        variant='text'
                        onClick={onOpenDocumentEditor}
                        startIcon={<IconEdit/>}
                    >
                        {t("Editor.edit")}
                    </Button>
                </div>
                <div>
                    <Button
                        variant='text'
                        onClick={onRemoveDocument}
                    >
                        {t("Editor.remove")}
                    </Button>
                </div>
            </div>
        </div>
    );
};
